

    <div class="sp-offcanvas-panel__body sp-scroll ps ps--active-y" style="height: 327px; overflow: hidden;">
        <div class="subtitle mb-4 mt-3">Tableros</div>
        <div class="sp-grid-nav-v2 mx-4">
            <a   *ngFor="let item of data;let indice=index" class="sp-grid-nav-v2__item mr-2" routerLink="/pageTabPanel" (click)="open(item)">
                <div class="sp-grid-nav-v2__item-icon">
                    <i class="fa-solid fa-id-badge"></i>
                </div>
                <div class="sp-grid-nav-v2__item-title">{{item.description.esCO}}</div>
            </a>
        </div>
    </div>